module.exports = __webpack_public_path__ + "img/8.35593603.jpg";